import "../../styles/global.scss";
import { Container, Row, Col, Form, Button, Alert, Card, Navbar, Nav } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import happyKids from "../../images/carerchild.png";
import logo from "../../images/logo.png";
import logoWhite from "../../images/logo-white.png";
import styles from "../../styles/login.module.scss";
import axios from "axios";
import { serverUrl } from "../../helpers/utility";
import { AnimatePresence, motion } from "motion/react";
import { useState } from "react";
import { mutate } from "swr";

function HomePage() {
  const navigate = useNavigate();
  // WARN: When editing use the ngrok domain as localhost will be blocked!

  // Mock care providers data
  const mockCareProviders = [
    { id: 1, name: "Sunshine Care Services", rating: 4.8, specializations: ["Foster Care", "Residential"] },
    { id: 2, name: "Family First Care", rating: 4.6, specializations: ["Emergency Placements", "Short-term"] },
    { id: 3, name: "Hope & Healing Homes", rating: 4.9, specializations: ["Therapeutic Care", "Long-term"] },
    { id: 4, name: "Safe Haven Care", rating: 4.7, specializations: ["Sibling Groups", "Respite"] },
    { id: 5, name: "Bright Futures Care", rating: 4.5, specializations: ["Teenage Care", "Supported Living"] },
    { id: 6, name: "Compassionate Care Network", rating: 4.8, specializations: ["Complex Needs", "Foster Care"] }
  ];

  return (
    <>
      <Container fluid className={`no-padding no-margin g-0 container-fluid`}>
        {/* Header */}
        <Navbar bg="white" expand="lg" className="border-bottom-0 py-3">
          <Container>
            <Navbar.Brand href="#home">
              <img
                src={logo}
                style={{ filter: "grayscale(50%)" }}
                width="150"
                height="auto"
                className="d-inline-block align-top"
                alt="bPlaced logo"
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link className="text-primary" href="#providers">
                  Browse Care Providers
                </Nav.Link>
                <Nav.Link className="text-primary" href="#about">
                  About
                </Nav.Link>
                <Nav.Link className="text-primary" href="#contact">
                  Contact
                </Nav.Link>
                <Button onClick={() => navigate("/login")} variant="outline-primary" className="ms-2 text-primary border-primary">
                  Sign In
                </Button>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <Row className="g-0">
          {/* Main content area */}
          <Col
            lg={8}
            xl={8}
            className={styles.loginMarketing}
            style={{ backgroundImage: `url(${happyKids})` }}
          >
            {/* Intro text overlay */}
            <div
              className="d-flex flex-column justify-content-start mt-5 w-75 h-100"
              style={{ zIndex: 2 }}
            >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-8">
                    <h1
                      className="text-white mb-4"
                      style={{ fontSize: "3.8rem", lineHeight: "1.1", fontWeight: "bold" }}
                    >
                      Finding young people the right home
                    </h1>
                    <p
                      className="text-white mb-3"
                      style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                    >
                      bPlaced is a secure, and innovative online platform, designed by social
                      workers, to connect placement teams with residential and foster home
                      providers.
                    </p>
                    <p className="text-white" style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                      Our unique matching process optimises home and placement searches – matched
                      specifically to individual needs, to get young people in the right homes for
                      them.
                    </p>
                    <Button variant="outline-primary" className="text-primary bg-white border-white">
                      Get Started
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* Care Providers Column */}
          <Col lg={4} xl={4} className="bg-primary px-4">
            <div className="d-flex flex-column h-100">
              <h4 className="text-primary mb-4">Featured Care Providers</h4>
              <div className="flex-grow-1 overflow-auto">
                {mockCareProviders.map((provider) => (
                  <Card key={provider.id} className="mb-3 shadow-sm">
                    <Card.Body className="p-3">
                      <Card.Title className="h6 text-primary mb-2">{provider.name}</Card.Title>
                      <div className="d-flex align-items-center mb-2">
                        <span className="text-warning me-1">★</span>
                        <span className="text-muted small">{provider.rating}</span>
                      </div>
                      <div className="d-flex flex-wrap gap-1">
                        {provider.specializations.map((spec, index) => (
                          <span
                            key={index}
                            className="badge bg-primary bg-opacity-10 text-primary"
                            style={{ fontSize: "0.7rem" }}
                          >
                            {spec}
                          </span>
                        ))}
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
              {/* <div className="mt-3">
                <Button variant="outline-primary" size="sm" className="w-100">
                  View All Providers
                </Button>
              </div> */}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default HomePage;
